export class UserSubscription {
  isEditing?: boolean;

  constructor(
    public name?: string,
    public activeFrom?: Date,
    public activeTo?: Date,
    public isActive?: boolean,
    public title?: string,
  ) {}
}
